/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import { Spin, Alert } from "antd";
import { Link } from "react-router-dom";
import * as S from "./style";
import { ArrowUpDown } from "lucide-react";

type Product = {
  _id: string;
  name: string;
  description: string;
  price: number;
  isInstock: boolean;
  isPreOrder?: boolean;
  images?: string[];
  category?: string;
  gender?: string;
  vintage?: boolean;
};

export const Vintage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch("https://vip-resale.com/api/products")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch products");
        return res.json();
      })
      .then((data) => {
        setProducts(data);
        setError(null);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spin style={{ margin: 40 }} />;

  if (error)
    return (
      <Alert
        type="error"
        message="Error"
        description={error}
        style={{ margin: 40 }}
      />
    );

  return (
    <section css={S.page}>
      <div css={S.inner}>
        <div css={S.topBlock}>
          <h1 css={S.title}>ВІНТАЖ</h1>

          <div css={S.filtersRow}>
            <button css={S.filterButton}>ФІЛЬТРИ</button>
            <button css={S.sortButton}>
              <ArrowUpDown size={20} strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div css={S.grid}>
          {products.map((product) => (
            <Link
              key={product._id}
              to={`/products/${product._id}`}
              css={S.card}
            >
              <div css={S.imageWrap}>
                {product.vintage && <span css={S.badge}>VINTAGE</span>}
                {product.isPreOrder && (
                  <span css={S.preOrderBadge}>ПІД ЗАМОВЛЕННЯ</span>
                )}

                {product.images?.[0] ? (
                  <img
                    css={S.image}
                    src={`https://vip-resale.com${product.images[0]}`}
                    alt={product.name}
                  />
                ) : (
                  <div css={S.noImage}>No Image</div>
                )}
              </div>

              <div css={S.cardBody}>
                <div css={S.brand}>{product.name}</div>
                <div css={S.price}>{product.price}$</div>
                {product.isPreOrder && (
                  <div css={S.status}>Під замовлення</div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
